<template>
    <MainPage pageTitle="ต่อประกัน เงินสด / ผ่อน" :bgClass="isNoData ? 'bg-white' : 'bg-a-gray-efefef'" v-if="isLoaded">
        <template v-if="isNoData">
            <NoDataRenewal />
        </template>
        <template v-else>
            <RenewalList :items="items" :channel="channel"/>
        </template>
    </MainPage>
</template>

<script>
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import { computed, defineComponent, inject, onMounted, ref } from 'vue';

// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import NoDataRenewal from '../component/NoDataRenewal.vue';
import RenewalList from '../component/RenewalList.vue';
import RenewalService from '../service/RenewalService.js';
import { useRoute } from 'vue-router';
import Utility from '@/helper/Utility';
import useAlertModal from '@/helper/composable/modal/useAlertModal';
import { useTracking } from "@/feature/TrackingFeature"

export default defineComponent({
    components: {
        MainPage,
        NoDataRenewal,
        RenewalList
    },
    setup: function () {
        const route = useRoute()
        const modalStore = inject("ModalStore")
        const { showApiErrorModal } = useAlertModal(modalStore)
        const { loadingModal } = useLoadingModal(modalStore)
        const isLoaded = ref(false)
        const items = ref([])
        const channel = ref('')

        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        const isNoData = computed(() => {
            if (isLoaded.value && items.value.length == 0) {
                return true
            }
            return false
        })

        const getRenewalList = function () {
            let paramsQuery = null
            let type = route.query.type ? route.query.type : null

            if (type != null && type.toLowerCase().indexOf('marketingtemplate') > -1) {
                paramsQuery = route.query
            }
            
            return new Promise((resolve) => {
                loadingModal.show();
                RenewalService.apiGetRenewals(paramsQuery).subscribe({
                    next: (renewalList) => {
                        loadingModal.hide();
                        console.log("renewalList",renewalList);
                        items.value = renewalList;
                        resolve(renewalList);
                        isLoaded.value = true
                    },
                    error: (err) => {
                        resolve(null);
                        showApiErrorModal("", err);
                        loadingModal.hide();
                    },
                });
            });
        }

        const logChannel = function(){
            let channel = route.params.channel || null
            // console.log(channel)
            if(!Utility.isEmptyStr(channel)){
                RenewalService.logChannel(channel)
            }
        }

        onMounted(() => {
            tracking.screenName('renewal_list')
            tracking.event("renewal_list_page", "view_renewal_list", "", "");
            channel.value = route.params.channel ? route.params.channel.toLowerCase() : 'null';
            logChannel()
            getRenewalList()
        })

        return {
            isLoaded,
            items,
            isNoData,
            channel
        }
    },
})
</script>


